@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/mixins/common" as c;

.modal {
  padding: 0;
  width: 576px;

  @include c.containerMedia(v.$tablet-breakpoint) {
    max-width: calc(100% - 30px);
  }
}

.contentBox {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: v.$palette-white;
  box-shadow: v.$shadow-2;
  border-radius: 16px;
  text-align: center;
  padding: 48px;
  width: 100%;
  min-height: 268px;
  height: auto;

  @include c.containerMedia(v.$tablet-breakpoint, "min") {
    width: 578px;
  }

  .title {
    @include t.text(20px, 30px, 600);
    color: v.$palette-gray-900;
    margin-bottom: 8px;
    max-width: 480px;
  }

  .description {
    @include t.text(14px, 22px, 400);
    color: v.$palette-gray-900;
    margin-bottom: 16px;
  }

  .buttonsWrapper {
    display: flex;
    gap: 16px;
  }

  .cancelButton {
    @include t.text(16px, 26px, 600);
    color: v.$palette-gray-900;
    background-color: v.$palette-gray-100;
    padding: 11px 24px;
    border-radius: 8px;
  }

  .updateButton,
  .buttonOk {
    @include t.text(16px, 26px, 600);
    padding: 11px 24px;
    border-radius: 8px;
  }

  .buttonOkLoading {
    background: v.$palette-gray-400;
    color: v.$palette-gray-100;
  }

  .buttonOkLoaded {
    color: v.$palette-gray-100;
    background: v.$palette-gray-900;
  }

  .progressText {
    display: flex;
    gap: 16px;
    justify-content: center;
    width: 100%;
    @include t.text(14px, 26px, 600);
    color: v.$palette-gray-900;
    margin-bottom: 16px;
  }

  .progressContainer {
    width: 100%;
    height: 4px;
    border-radius: 3px;
    background: v.$palette-gray-200;
    margin-bottom: 16px;

    @include c.containerMedia(v.$tablet-breakpoint, "min") {
      width: 370px;
    }
  }

  .progressBar {
    height: 100%;
    border-radius: 3px;
    border-radius: 3px;
    transition: width 0.5s ease;
  }

  .progressLoading {
    background: linear-gradient(60deg, #50adff 0%, #006ff1 100%);
  }

  .progressLoaded {
    background: linear-gradient(60deg, #13c549 0%, #0dbbbb 100%);
  }
}

.closeBtn {
  display: block;
  position: absolute;
  padding: 0;
  margin: 0;
  width: 22px;
  height: 22px;
  top: 24px;
  right: 24px;
  color: v.$palette-gray-900;
  cursor: pointer;

  svg path {
    fill: v.$palette-gray-900;
  }
}

.errorTitle {
  @include t.text(16px, 22px, 600);
  color: v.$palette-gray-900;
  margin-bottom: 16px;
  text-align: center;
  width: 100%;
}

.errorList {
  width: 230px;
  max-height: 200px;
  overflow-y: auto;
  margin: 0 0 16px 0;
  padding: 0;
  list-style: none;
  border-radius: 16px;
  background-color: v.$palette-gray-100;

  &::-webkit-scrollbar {
    display: none;
  }

  @include c.containerMedia(v.$tablet-breakpoint, "min") {
    width: 360px;
  }

  li {
    @include t.text(14px, 22px, 400);
    color: v.$palette-gray-900;
    padding: 16px;
    text-transform: uppercase;
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .copyButton {
      @include t.text(12px, 20px, 500);
      color: v.$palette-gray-900;
      cursor: pointer;
      width: 47px;
      height: 28px;
      padding: 4px 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-transform: none;
      border-radius: 8px;
      background-color: v.$palette-gray-200;

      &:hover {
        color: v.$palette-blue-1;
      }
    }
  }
}
